module.exports = __webpack_public_path__ + "static/media/zombie_1f9df.e8917bf4.png";